import { PropsWithChildren, MouseEvent } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useInitContext } from '~/app/providers/InitProvider/hooks/useInitContext';

import { BasicLinkProps, isRouterLink, RouterLinkProps } from './Link.types';
import { StyledLink } from './Link.ui';

export type LinkProps = PropsWithChildren<BasicLinkProps | RouterLinkProps>;

export const Link = (props: LinkProps) => {
  const { children, rel = '', target, href, onClick, ...linkProps } = props;
  const { openLink } = useInitContext();

  const resultRel =
    (target === '_blank' ? `${rel} noopener noreferrer` : rel).trim() ||
    undefined;

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (target === '_blank' && href && !isRouterLink(linkProps)) {
      e.preventDefault();

      const fullUrl = href.startsWith('http')
        ? href
        : `${window.location.origin}${href.startsWith('/') ? '' : '/'}${href}`;

      openLink(fullUrl);
      return;
    }

    if (onClick) {
      onClick(e);
    }
  };

  if (isRouterLink(linkProps)) {
    return (
      <StyledLink
        {...linkProps}
        as={RouterLink}
        rel={resultRel}
        target={target}
        onClick={handleClick}
      >
        {children}
      </StyledLink>
    );
  }

  return (
    <StyledLink
      {...linkProps}
      href={href}
      rel={resultRel}
      target={target}
      onClick={handleClick}
    >
      {children}
    </StyledLink>
  );
};
